module.exports = __webpack_public_path__ + "img/27.a09e492f.png";